import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import RoomTypeList from './RoomTypeList';
import ResultLoader from 'components/Loader/ResultLoader';
import LoaderSkeletonCard from './LoaderSkeletonCard';
import { getIsExclusive, getRoomTypesWithoutOffers } from 'store/property/propertySelectors';
import { getHasValidQuery, getIsLoading, getSortedAvailableRoomTypes } from 'store/propertyAvailability/propertyAvailabilitySelectors';
import {
  getIsLoading as getIsLoadingExclusive,
  getExclusiveOfferRoomTypeCount,
  getExclusiveOfferRoomTypes,
} from 'store/exclusiveOffer/exclusiveOfferSelectors';

//memoised to prevent unnecessary renders when ResultLoader state changes
const LoaderResults = React.memo(({ availableRoomTypes, hasQuery }) => {
  return (
    <>
      <RoomTypeList roomTypes={availableRoomTypes} hasQuery={hasQuery} showPhoneFilters />
    </>
  );
});

LoaderResults.displayName = 'LoaderResults';

LoaderResults.propTypes = {
  availableRoomTypes: PropTypes.array.isRequired,
  hasQuery: PropTypes.bool.isRequired,
};

const RoomTypes = React.memo(() => {
  const hasQuery = useSelector(getHasValidQuery);
  const isLoading = useSelector(getIsLoading);
  const isLoadingExclusive = useSelector(getIsLoadingExclusive);
  const isExclusive = useSelector(getIsExclusive);

  const availableRoomTypes = useSelector(getSortedAvailableRoomTypes) || [];
  const roomTypesWithoutOffers = useSelector(getRoomTypesWithoutOffers) || [];
  const exclusiveRoomTypesCardData = useSelector(getExclusiveOfferRoomTypes) || [];
  const totalExclusiveRoomOffers = useSelector(getExclusiveOfferRoomTypeCount);
  const skeletonLoaderSize = availableRoomTypes.length || 5;

  if (isExclusive) {
    return (
      <ResultLoader
        isLoading={isLoadingExclusive}
        skeletonResultCount={totalExclusiveRoomOffers}
        skeletonCardComponent={LoaderSkeletonCard}
      >
        <RoomTypeList roomTypes={exclusiveRoomTypesCardData} hasQuery={false} />
      </ResultLoader>
    );
  }

  return hasQuery ? (
    <ResultLoader isLoading={isLoading} skeletonResultCount={skeletonLoaderSize} skeletonCardComponent={LoaderSkeletonCard}>
      <LoaderResults availableRoomTypes={availableRoomTypes} hasQuery={hasQuery} />
    </ResultLoader>
  ) : (
    <RoomTypeList roomTypes={roomTypesWithoutOffers} hasQuery={hasQuery} />
  );
});

RoomTypes.displayName = 'RoomTypes';

export default RoomTypes;
